import Icon from "@mui/icons-material/History";
import SabilAuditPlaceholderList from "../sabil-audit-resource";

export default {
  list: SabilAuditPlaceholderList,
  icon: Icon,
  name: "sabilAudit",
  options: { label: "Sabil change history" },
};
